import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { whoWeCareFor } from '../../data/features';
import { container } from '../../utils/styles';
import { SectionHeading } from '../shared/SectionHeading';
export function WhoWeCareFor() {
  const {
    t
  } = useLanguage();
  return <section id="who-we-care-for" className="scroll-mt-36 bg-white py-20 sm:py-24" aria-labelledby="care-for-heading" data-id="element-71" data-mp="1r6hvpw8u2fzo">
      <div className={`${container} grid gap-12 lg:grid-cols-12 lg:gap-16`} data-id="element-72" data-mp="2nv5zbnjsy0pk">
        <div className="lg:col-span-4" data-id="element-73" data-mp="2iwmdro94eqxq">
          <SectionHeading id="care-for-heading" title={t({
          en: 'Who We Care For',
          es: 'A Quién Cuidamos'
        })} intro={t({
          en: 'Every stage of life brings different needs. We tailor care to where your loved one is today.',
          es: 'Cada etapa de la vida trae necesidades distintas. Adaptamos el cuidado a donde está tu ser querido hoy.'
        })} data-id="element-74" data-mp="2ixnn9oahn5dc" />
        </div>
        <ul className="grid gap-x-10 gap-y-10 sm:grid-cols-2 lg:col-span-8" data-id="element-75" data-mp="3m7utoias7ccd">
          {whoWeCareFor.map(item => {
          const Icon = item.icon;
          return <li key={item.id} className="flex gap-5" data-id="element-76" data-mp="3r4uzqt7msf3h">
                <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-gold-light text-gold-dark" aria-hidden="true" data-id="element-77" data-mp="3d7zfs5pud38n">
                  <Icon className="h-7 w-7" data-id="element-78" data-mp="3i8dlhh3z013i" />
                </span>
                <div data-id="element-79" data-mp="33gl8vcvk915h">
                  <h3 className="text-xl font-bold text-ink" data-id="element-80" data-mp="33fa357ik1jbq">{t(item.title)}</h3>
                  <p className="mt-2 leading-relaxed text-ink-soft" data-id="element-81" data-mp="389o3loc2qgn9">{t(item.body)}</p>
                </div>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}